import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import socketIOClient from 'socket.io-client';

const createDefaultSocket = () => socketIOClient('/');

const useSessionSocket = ({ s_id, accessModules, checkAccess, createSocket = createDefaultSocket }) => {
  const socketRef = useRef(null);
  const [sessionSocket, setSessionSocket] = useState(null);

  useLayoutEffect(() => {
    if (!s_id) {
      setSessionSocket(null);
      return undefined;
    }

    const socket = createSocket();
    socketRef.current = socket;
    setSessionSocket(socket);

    const handleAccessModulesUpdated = () => {
      checkAccess();
    };

    socket.on('access-modules-updated', handleAccessModulesUpdated);

    return () => {
      socket.off('access-modules-updated', handleAccessModulesUpdated);
      socket.disconnect();

      if (socketRef.current === socket) {
        socketRef.current = null;
      }

      setSessionSocket(null);
    };
  }, [s_id, checkAccess, createSocket]);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !s_id || !accessModules) {
      return undefined;
    }

    const registerSocket = () => {
      socket.emit('register', {
        s_id,
        accessModules,
      });
    };

    if (socket.connected) {
      registerSocket();
    }

    socket.on('connect', registerSocket);

    return () => {
      socket.off('connect', registerSocket);
    };
  }, [s_id, accessModules]);

  return {
    sessionSocket,
    socketRef,
  };
};

export default useSessionSocket;
